import React, { useEffect, useRef } from "react";
import { PriceTag } from "../../../Property/PriceTag/web";
import { useSeenStatus } from "../../../Property/SeenStatus/SeenStatus.hook";
import { useTheme } from "../../../../Styles/ThemeHook";
import "./styles.less";

const K_LISTING_MARKER_SIZE = 10;

const ListingMarker = props => {
	const {
		key,
		id,
		text,
		lat,
		lng,
		$hover = false,
		active,
		zoomPrecio,
		updateInfoWindowPosition,
		onClick,
		listing,
		zoom = 14,
		pointType = false,
	} = props;

	const { result: seen } = useSeenStatus({ id });
	const { theme } = useTheme();

	const ref = useRef(null);

	const scale = size => {
		if (size >= 17) {
			return "8px";
		} else if (size >= 15) {
			return "3px";
		} else {
			return "1px";
		}
	};

	const size = pointType
		? { width: `calc(${zoom} * ${scale(1)})`, height: `calc(${zoom} * ${scale(1)})` }
		: null;

	const sizeHover = `calc(${zoom} * ${scale(zoom)}) !important`;

	const dotColor = seen ? "#9b9b9b" : theme.colors.primaryColor;

	useEffect(() => {
		if (active) updateInfoWindowPosition(ref.current?.getBoundingClientRect());
	}, [active]);

	const handleClick = e => {
		e.stopPropagation();
		if (typeof onClick == "function") onClick(listing, props);
	};

	return (
		<>
			<div className="map-marker" ref={ref} onClick={handleClick}>
				{zoomPrecio && !pointType ? (
					<div className="map-marker-price">
						<div className="content">
							<PriceTag
								showExpenses={false}
								threeDigitsFormat={true}
								showFromText={false}
								price={listing.price}
								temporalPrice={listing.temporal_price}
								temporalCurrency={listing.temporal_currency}
							/>
						</div>
						<div className="arrow" />
					</div>
				) : (
					<div
						className={pointType ? "map-marker-point" : "map-marker-dot"}
						style={size}
					>
					</div>
				)}
			</div>
			<style jsx>
				{`
					.map-marker-dot {
						background-color: ${$hover || active
						? theme.colors.secondaryColor
						: dotColor};
						z-index: ${$hover || active ? 3 : 2};
						box-shadow: ${$hover
						? "0 0 0 " +
						theme.spacing.smSpacing +
						"px " +
						theme.colors.primaryHoverColor
						: "none"};
					}
					.map-marker-point,
					.map-marker-point-zoom {
						background-color: ${$hover || active
						? theme.colors.secondaryColor
						: dotColor};
						opacity: ${0.5};
						width: ${$hover || active
						? sizeHover
						: "initial"};
						height: ${$hover || active
						? sizeHover
						: "initial"};
						transition: 0.75s
					}
					.map-marker-price {
						z-index: ${$hover || active ? 3 : 2};
					}
					.map-marker-price .content {
						background: ${$hover || active ? theme.colors.secondaryColor : dotColor};
					}
					.map-marker-price .arrow {
						border-top-color: ${$hover || active
						? theme.colors.secondaryColor
						: dotColor};
					}
				`}
			</style>
		</>
	);
};

export { ListingMarker, K_LISTING_MARKER_SIZE };
